import {
    DOCKER_REGISTRY_REQUEST_GET,
    DOCKER_REGISTRY_RESPONSE_GET_SUCCESS,
    DOCKER_REGISTRY_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/dockerRegistryConstancts";
  
  export const dockerRegistryShReducer = (state = { dockerRegistry: {} }, action) => {
    switch (action.type) {
      case DOCKER_REGISTRY_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case DOCKER_REGISTRY_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          dockerRegistry: action.payload,
        };
      case DOCKER_REGISTRY_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  